/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
//import Footer from "components/Footer/Footer.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2025/02/facebook-scams/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2025/02/facebook-scams/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";
//import SectionSimilarStories from "pages-sections/blog-post/2024/01/using-streamlit-to-build-web-applications/SectionSimilarStories.js";





export const metadata = {
  title: "Facebook Scams",
  date: "2025-02-04",
  summary: "We are an Australian Analytics | Web Development | Digital Marketing Agency based in Melbourne. We can help you with all types of applications such as Streamlit !",
  image: "/img/posts/2025-02-04-facebook-scams/Fake-Facebook-Ad-small.jpg",
  url: "https://www.tribalism.com.au/blog-post/2025/02/facebook-scams",
  author: "Scott Sunderland"
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Facebook Scams"
        image="/img/posts/2025-02-04-facebook-scams/Fake-Facebook-Ad-small.jpg"
        url="https://www.tribalism.com.au/blog-post/2025/02/facebook-scams"
        type="article"
        description="We are an Australian Analytics | Web Development | Digital Marketing Agency based in Melbourne. We can help you with all types of applications such as Streamlit !"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax
        image="/img/posts/2025-02-04-facebook-scams/Fake-Facebook-Ad-small.jpg"
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
                Please Ignore Scam Job Posts On Facebook
              </h1>
              <h4 className={classes.subtitle}>
              There are a number of scams running around facebook community groups in the Australia/Melbourne/Victoria area and unfortunately Tribalism have been dragged in to it.
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
        </div>
      </div>
      

      <Footer />
    </div>
  );
}
